const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {Portal} = require("./Portal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const _ = require("lodash");

const styles = require("./styles/HoverText.css");

module.exports = createReactClass({
	displayName: "HoverText",

	propTypes: {
		className: PT.string,
		style: PT.object,
		text: PT.string,
		// Determines max-width of text box
		size: PT.oneOf(["small", "medium", "large"]),
		//location of tooltip relative to element:
		// b = bottom, t = top, l = left of element, r = right of element, R = right-aligned to element, T = almost top-aligned with element
		canWrap: PT.bool,
		direction: PT.oneOf([
			"tl",
			"tr",
			"bl",
			"br",
			"t",
			"r",
			"l",
			"b",
			"bR",
			"T",
		]),
	},

	getDefaultProps: function() {
		return {
			size: "small",
			direction: "r",
		};
	},

	getInitialState: function() {
		return {
			isHovering: false,
		};
	},

	startHover: function(evt) {
		evt.preventDefault();
		this.setState({isHovering: true});
	},

	endHover: function(evt) {
		evt.preventDefault();
		this.setState({isHovering: false});
	},

	render: function() {
		let tooltip = null;
		const {text, size, direction, className, canWrap} = this.props;
		const {isHovering} = this.state;
		if (text && isHovering && this.element) {
			const el = this.element.getBoundingClientRect();
			const position = _.pick(el, ["top", "left"]);
			position.top += window.scrollY;
			if (_.includes(direction, "t")) {
				position.top -= el.height;
				position.transform = "translateY(-100%)";
			}
			if (_.includes(direction, "b")) {
				position.top += el.height;
			}
			if (_.includes(direction, "l")) {
				position.transform = "translateX(-100%)";
			}
			if (_.includes(direction, "r")) {
				position.left += el.width;
			}
			if (_.includes(direction, "R")) {
				position.left += el.width;
				position.transform = "translateX(-100%)";
			}
			if (_.includes(direction, "T")) {
				position.transform = "translateY(-110%)";
			}

			let tooltipClass = styles[size];
			if (!canWrap) tooltipClass += " " + styles.noWrap;
			tooltip = (
				<Portal container={PORTAL_CONTAINERS.HOVER_TEXT}>
					<div className={tooltipClass} style={position}>
						{text}
					</div>
				</Portal>
			);
		}

		let mainClass = styles.main;
		if (className) mainClass += " " + className;

		return (
			<div
				ref={e => (this.element = e)}
				onMouseEnter={this.startHover}
				onMouseLeave={this.endHover}
				className={mainClass}
				style={this.props.style}
			>
				{this.props.children}
				{tooltip}
			</div>
		);
	},
});
